import { getRowFormatted, RowType } from './useTable';

export const useTimeWindow = (props: any) => {
  const tab = {
    isTimeWindowEnable: props?.isTimeWindowEnable ?? false,
  };

  const getDataRow = (row: RowType) => getRowFormatted(row);

  return {
    ...tab,
    tab,
    getDataRow,
  };
};
